@if (configured) {
  <app-route-progress />
  <router-outlet />
} @else {
  <div class="page">
    <h1>Missing Supabase configuration</h1>
    <p class="text-muted">
      <code>supabaseKey</code> is empty in <code>src/environments/environment.development.ts</code>.
      Fill it in from the Supabase dashboard (Settings &gt; API) for project
      <code>qbaamzphxgfjavyercpz</code>.
    </p>
  </div>
}
